/* Trust Badges — Scroll animation via IntersectionObserver */
(function () {
  'use strict';

  var targets = document.querySelectorAll('.tb--animate');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    /* Fallback: show immediately */
    targets.forEach(function (el) { el.classList.add('tb--visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tb--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  targets.forEach(function (el) { observer.observe(el); });
})();
